import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from '../../store/modules/search/actionTypes';
import { search } from './utils';

export default function* listenSearch() {
  yield takeEvery(actionTypes.SEARCH, search);
}
